<app-page padding="0">
  <div class="h-full p-0">
    <div class="flex flex-column align-items-center justify-content-center h-full p-1 gap-1 lg:gap-3">
      <div class="flex flex-column md:flex-row align-items-center justify-content-between gap-1 lg:gap-3">
        <div class="gap-1">
          <div class="text-md font-semibold text-700"><span class="text-700 font-light">Elaborazione: </span>{{id}}</div>
          <!-- <div class="text-md"><span class="text-700 font-light">Ultima Modifica: </span>{{ selectedFile().lastModified | date:'dd/MM/yyyy' }}</div>
          <div class="text-md"><span class="text-700 font-light">Dimensione: </span>{{ selectedFile().size | appFilesize }}</div>
          <div class="text-md"><span class="text-700 font-light">Tipo: </span>{{ selectedFile().type }}</div> -->
        </div>
        <div>
          <span>
            <mat-spinner></mat-spinner>
          </span>
        </div>
      </div>
    </div>
  </div>
</app-page>
